import script from "./todo_list.vue?vue&type=script&setup=true&lang=js"
export * from "./todo_list.vue?vue&type=script&setup=true&lang=js"

import "./todo_list.vue?vue&type=style&index=0&id=e9fe3964&lang=css"

const __exports__ = script;

export default __exports__